import {Form, message} from 'antd';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useHistory, useRouteMatch} from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import useLoading from '../../../../hooks/useLoading';
import {fetchRepresentante, fetchRepresentantes, representanteSelector} from '../../../../store/empresa';
import {valuesToFormData} from '../../../../util/formData';
import unwrapAxiosPromise from '../../../../util/unwrapAxiosPromise';
import EmpresaRepresentanteForm from './_form';
import useModulo from "../../../../hooks/useModulo";

export default function EmpresaRepresentanteEditPage() {
  const {t} = useTranslation();
  const dispatch = useDispatchWithResult();
  const [form] = Form.useForm();
  const representante = useSelector(representanteSelector);
  const loading = useLoading(fetchRepresentante.typePrefix);
  const [loadingSave, setLoadingSave] = useState(false);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const {moduloBasePath} = useModulo();

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(representante);
    setImmediate(() => document.querySelector('#socioId').focus());
  }, [representante]);

  const handleFinish = values => {
    setLoadingSave(true);
    const formData = valuesToFormData(values);
    unwrapAxiosPromise(axios.put(`/empresas/${empresaId}/representantes/${id}`, formData), form)
        .then(() => {
          message.success(t('Registro alterado com sucesso'));
          history.replace(`${moduloBasePath}/empresas/${empresaId}/representantes/${id}`);
          dispatch(fetchRepresentantes({empresaId}));
          dispatch(fetchRepresentante({empresaId, id}));
        })
        .finally(() => setLoadingSave(false));
  };

  const handleCancel = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/representantes/${id}`);
  };

  const title = (
      <ActionBar>
        <ActionButton.Save onClick={form.submit} loading={loadingSave} />
        <ActionButton.Cancel onClick={handleCancel} disabled={loadingSave} />
      </ActionBar>);

  return (
      <EmpresaRepresentanteForm
          disabled={loadingSave}
          empresaId={empresaId}
          form={form}
          loading={loading}
          onFinish={handleFinish}
          title={title}
      />);
}
